/**
 * Delivery Estimation — GoPadFree
 * Adapted from delivery-estimation-theme-ext/assets/ExpDelivery.js
 */
class DeliveryEstimator {
  constructor(root) {
    this.apiEndpoint = 'https://www.webserver.healthfab.in/calculateDeliveryTime';
    this.root       = root;
    this.input      = root.querySelector('.dest-input');
    this.btn        = root.querySelector('.dest-btn');
    this.output     = root.querySelector('.dest-output');
    this.pickupTime = parseFloat(root.dataset.pickupTime || '12');

    if (this.btn) this.btn.addEventListener('click', () => this.handleSubmit());
    if (this.input) {
      this.input.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') this.handleSubmit();
      });
      // Digits only
      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/[^0-9]/g, '');
      });
    }
  }

  async handleSubmit() {
    const pincode = this.input ? this.input.value.trim() : '';

    if (!this.validate(pincode)) {
      this.show('Please enter a valid 6-digit pincode.', 'error');
      return;
    }

    this.show('Checking delivery availability\u2026', 'loading');
    this.btn.disabled = true;

    try {
      const res = await fetch(this.apiEndpoint, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ postal_code: pincode, payment_method: this.getPaymentMethod() }),
      });

      if (!res.ok) throw new Error('Network error');

      const data = await res.json();
      this.display(data);
    } catch (err) {
      console.error('[DeliveryEstimator]', err);
      this.show('Unable to check delivery. Please try again.', 'error');
    } finally {
      this.btn.disabled = false;
    }
  }

  validate(pin) {
    return /^[1-9][0-9]{5}$/.test(pin);
  }

  getPaymentMethod() {
    return document.querySelector('input[name="payment_method"]:checked')?.value || 'cod';
  }

  display(data) {
    if (data.status === 'success' || data.status === 'fallback') {
      this.show(data.delivery_message || data.message, 'success');
    } else {
      this.show(data.message || 'Delivery information not available for this pincode.', 'error');
    }
  }

  show(msg, type = 'info') {
    if (!this.output) return;
    this.output.innerHTML = msg;
    this.output.className = 'dest-output dest-output--' + type;
  }
}

// Init every instance on the page (supports multiple sections / quick-view)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dest-widget').forEach((el) => new DeliveryEstimator(el));
});
